import { render, staticRenderFns } from "./SamplesListItem.vue?vue&type=template&id=535d2fe4&scoped=true&"
import script from "./SamplesListItem.vue?vue&type=script&lang=js&"
export * from "./SamplesListItem.vue?vue&type=script&lang=js&"
import style0 from "./SamplesListItem.vue?vue&type=style&index=0&id=535d2fe4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d2fe4",
  null
  
)

export default component.exports